module.exports = __webpack_public_path__ + "img/your_irrumatio.74c3c838.jpg";